<template>
  <el-dialog
    class="importModal"
    title="批量导入"
    :visible.sync="modalInfo.isShow"
    v-if="modalInfo.isShow"
    :close-on-click-modal="false"
    width="30%"
  >
    <el-upload
      ref="newupload"
      class="upload-demo"
      drag
      multiple
      action="http://192.168.1.96:8000/hcm/hcmKeywords/readExcelFile"
      :before-upload="beforeUpload"
      :auto-upload="false"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        <p>点击这里选择文件上传</p>
        <p>支持扩展名：.xls .xlsx</p>
      </div>
    </el-upload>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" class="cancel" @click="modalInfo.isShow = false">取 消</el-button>
      <el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import axios from "axios";
export default {
  name: "importModal",
  props: {
    modalInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      query: {
        platform: "sdhsj"
      }
    };
  },
  methods: {
    beforeUpload(file) {
      let _this = this;
      let fd = new FormData();
      fd.append("file", file);
      fd.append("platform", this.modalInfo.platform);
      const instance=axios.create({
        headers:{
          "Content-Type": "multipart/form-data"
        },
        timeout: (60 * 1000)*5,
      })
      instance.post("/hcm/hcmKeywords/readExcelFile", fd).then(function(res) {
        if (res.data.status == "10000") {
          _this.$message.success(res.data.message);
           _this.modalInfo.isShow = false;
          _this.$emit("reqTableData")
        } else {
          _this.$message.error(res.message ? res.message : "导入失败！");
        }
      });
      return false;
    },
    confirmClick() {
      this.$refs.newupload.submit();
    }
  }
};
</script>
<style lang="scss">
</style>


